import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { Icon, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { ShieldCheckGradient } from '@repo/ui/icons';
import { memo } from 'react';
import { useAutoDeleverage } from '../hooks/useAutoDeleverage';
import { useIsAutoDeleverageEnabled } from '../hooks/useIsAutoDeleverageEnabled';
interface ProtectedValueIndicatorProps {
  marketId: MarketId;
  chainId: ChainId;
}
const ProtectedValueIndicator = t0 => {
  const $ = _c(1);
  const {
    marketId,
    chainId
  } = t0;
  const isAutoDeleverageEnabled = useIsAutoDeleverageEnabled(chainId);
  const {
    status: autoDeleverageStatus
  } = useAutoDeleverage(marketId, chainId);
  if (!isAutoDeleverageEnabled || autoDeleverageStatus !== "authorized") {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tooltip><TooltipTrigger asChild={true}><Icon icon={<ShieldCheckGradient />} /></TooltipTrigger><TooltipContent>This value takes into account the Auto-Deleverage LTV.</TooltipContent></Tooltip>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};
export default memo(ProtectedValueIndicator);